let CONST = {}

CONST.ENTITY_LINK_TYPES = [
  "Actor",
  "Item",
  "Scene",
  "JournalEntry",
  "Macro",
  "RollTable"
]

export default CONST
